import React from 'react';
import CtaBackground from '../assets/images/property/pmgluxury/Isamorada_Boating_Bar_sunset.jpg';

const valueProps = [
  {
    title: 'Direct Gulf Access',
    desc: 'Private docks, boat lifts, and rare grandfathered Islamorada slips on the water you came for.',
  },
  {
    title: 'Turnkey & Furnished',
    desc: 'Fully furnished homes with all utilities, internet, and maintenance included. Pull in and unwind.',
  },
  {
    title: 'Personal Concierge',
    desc: 'Direct line to the owners. No call centers, no corporate templates — just a real welcome.',
  },
];

export default function Cta() {
  return (
    <section
      style={{ backgroundImage: `url(${CtaBackground})` }}
      className="relative py-28 md:py-36 bg-no-repeat bg-center bg-fixed bg-cover"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/70 via-slate-900/60 to-slate-900/85"></div>

      <div className="container relative">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <p className="font-display italic text-gold-400 tracking-[0.3em] uppercase text-xs md:text-sm mb-5">
            — The PMG Difference —
          </p>
          <blockquote className="font-display italic text-white text-2xl md:text-4xl leading-snug">
            “Bring your boat. Bring your jet skis. Pull in and enjoy.”
          </blockquote>
          <div className="flex items-center justify-center gap-3 mt-6">
            <span className="h-px w-10 bg-gold-500/70"></span>
            <span className="text-gold-200 tracking-[0.25em] uppercase text-xs">A Florida Hidden Gem</span>
            <span className="h-px w-10 bg-gold-500/70"></span>
          </div>
        </div>

        <div className="grid md:grid-cols-3 grid-cols-1 gap-10 max-w-5xl mx-auto">
          {valueProps.map((p, i) => (
            <div key={i} className="text-center px-4">
              <h5 className="font-display text-gold-300 text-xl md:text-2xl mb-3 tracking-wide">
                {p.title}
              </h5>
              <p className="text-slate-200/90 leading-relaxed text-[15px]">
                {p.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
